import React, { lazy, Suspense } from "react";
import "./assets/css/style.css";
import "./assets/css/responsive.css";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import CSFooter from "./components/CSFooter";
import CSNav2 from "./components/CSNav2";


// استخدام React.lazy لتحميل المكونات عند الحاجة
const Home = lazy(() => import("./pages/Home"));
const Contact = lazy(() => import("./pages/Contact"));
const Policy = lazy(() => import("./pages/Policy"));
const Dashboard = lazy(() => import("./pages/Dashboard"));


function App() {
  return (
    <>
      <CSNav2 />
      <Suspense fallback={<section className="section-loading"></section>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/policy" element={<Policy />} />
          <Route
            path="/dashboard-app-control-dashboard"
            element={<Dashboard />}
          />
        </Routes>
      </Suspense>
      <CSFooter />
    </>
  );
}

export default App;
